module.exports = __webpack_public_path__ + "static/media/96.25f4d157.png";